<div class="section-details">
    <div class="section-header">
        <div class="section-title-container">
            <div class="section-title">
                {{ "edit-general-information.title" | t }}
            </div>
            <cerrix-instructions-icon
                [instructionText]="
                    'edit-general-information.instructionText' | t
                "
                [showText]="false"
            ></cerrix-instructions-icon>
        </div>
        <div class="section-subtitle">
            {{ "edit-general-information.subTitle" | t }}
        </div>
    </div>
    @if (editModel) {
        <div class="section-fields">
            <cerrix-input-group
                [name]="'asset-name'"
                data-uiid="asset-edit-name"
                appValidationRequired
                [infoText]="'edit-general-information.nameInfo' | t"
                [value]="editModel.name"
                (valueChange)="editModel.name = $event"
            >
                {{ "edit-general-information.nameLabel" | t }}
            </cerrix-input-group>
            <cerrix-textarea-group
                [name]="'asset-description'"
                data-uiid="asset-edit-description"
                [textareaDialogTitle]="
                    'edit-general-information.descriptionLabel' | t
                "
                [infoText]="'edit-general-information.descriptionInfo' | t"
                [rows]="5"
                [placeholder]="
                    'edit-general-information.descriptionPlaceholder' | t
                "
                [value]="editModel.description"
                (valueChange)="editModel.description = $event"
            >
                {{ "edit-general-information.descriptionLabel" | t }}
            </cerrix-textarea-group>
            @if (optionsLoaded && showThirdPartySelection) {
                <app-cerrix-select-group
                    name="asset-third-party"
                    data-uiid="asset-edit-third-party"
                    [infoText]="
                        'edit-general-information.thirdPartyInfo' | t
                    "
                    [options]="thirdPartyOptions"
                    [selectedValue]="editModel?.thirdPartyId"
                    (selectionChange)="onThirdPartyChange($event)"
                >
                    {{ "edit-general-information.thirdPartyLabel" | t }}
                </app-cerrix-select-group>
                <app-cerrix-select-group
                    name="asset-contract"
                    data-uiid="asset-edit-contract"
                    [options]="contractOptions"
                    [infoText]="'edit-general-information.contractInfo' | t"
                    [selectedValue]="editModel?.contractId"
                    [disabled]="isContractDisabled"
                    (selectionChange)="onContractChange($event)"
                >
                    {{ "edit-general-information.contractLabel" | t }}
                </app-cerrix-select-group>
            }
            @if (optionsLoaded && !showThirdPartySelection) {
                <span class="no-rights-text" data-uiid="asset-edit-no-third-party-rights">
                    {{
                        "edit-general-information.noThirdPartyRightsText"
                            | t
                    }}
                </span>
            }
        </div>
    }
</div>

<div class="slide-out-footer">
    <cerrix-button
        buttonType="secondary"
        buttonSize="big"
        secondaryColor="filled"
        data-uiid="asset-management-edit-cancel"
        (click)="closeEdit.emit()"
    >
        {{ "detail.cancelButton" | t }}
    </cerrix-button>
    <cerrix-button
        buttonType="primary"
        buttonSize="big"
        data-uiid="asset-management-edit-save-section"
        [disabled]="editSaving"
        (click)="save()"
    >
        {{ "detail.editSaveButton" | t }}
    </cerrix-button>
</div>
